import React from 'react'
import emojiMartData from '@emoji-mart/data'
import classNames from 'classnames'

import type { EmojiData } from './types'
import { capitalize } from './utils'
import { isMacLike } from './utils/isMacLike'

const { sheet } = emojiMartData
export type EmojiProps = {
  emoji: EmojiData
  size?: number | string
  fontSize?: number
  className?: string
  style?: React.CSSProperties
  index?: number
  onClick?: (event: EmojiData) => void
  forceApple?: boolean
  useSpriteSheet?: boolean
}

export const Emoji = ({
  emoji,
  size = 32,
  className,
  onClick,
  style,
  forceApple,
  useSpriteSheet = false,
}: EmojiProps) => {
  const [cannotLoad, setCannotLoad] = React.useState(false)
  const handleOnClick = () => onClick?.(emoji)
  const emojiSet = forceApple || isMacLike ? 'apple' : 'google'
  const emojiSkin = emoji.skins[0] // default value while we don't handle it
  if (!emojiSkin) {
    return <span /> // Need to better type emojiSkin in EmojiData, it's supposed to always have 1+ item
  }
  const imageSrc = `https://assets.slite.com/emojis/14.0.0/${emojiSet}/64/${emojiSkin.unified}.png`
  const spritesheetSrc = `https://assets.slite.com/emojis/14.0.0/${emojiSet}/sheets-256/64.png`

  if (cannotLoad) {
    return (
      <span
        className={classNames(className, 'flexbox flexbox-centered')}
        title={emoji.name}
        style={{
          ...style,
          height: size,
          width: size,
        }}
      >
        {emojiSkin.native}
      </span>
    )
  }

  return (
    <>
      {!useSpriteSheet || !emojiSkin || !emojiSkin.x || !emojiSkin.y ? (
        <img
          // eslint-disable-next-line formatjs/no-literal-string-in-jsx
          aria-label={emoji.id || 'emoji'}
          data-test-id={`emoji${capitalize(emoji.id)}`}
          className={className}
          onClick={handleOnClick}
          style={{
            ...style,
            height: size,
            width: size,
            objectFit: 'contain',
            objectPosition: 'center',
            verticalAlign: 'text-bottom',
          }}
          onError={() => setCannotLoad(true)}
          alt={emoji.name}
          src={imageSrc}
        />
      ) : (
        <span
          // eslint-disable-next-line formatjs/no-literal-string-in-jsx
          aria-label={emoji.id || 'emoji'}
          data-test-id={`emoji${capitalize(emoji.id)}`}
          className={className}
          onClick={handleOnClick}
          style={{
            ...style,
            display: 'block',
            width: size,
            height: size,
            backgroundImage: `url(${spritesheetSrc})`,
            backgroundSize: `${100 * sheet.cols}% ${100 * sheet.rows}%`,
            backgroundPosition: `${(100 / (sheet.cols - 1)) * emojiSkin.x}% ${
              (100 / (sheet.rows - 1)) * emojiSkin.y
            }%`,
          }}
        ></span>
      )}
    </>
  )
}
